import './index.css'

import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom'

import AppContainer from './AppContainer'
import Store from './store'

ReactDOM.render(
  <StrictMode>
    <AppContainer store={Store} />
  </StrictMode>,
  document.getElementById('root-utargi-web'),
)
